import { CountryCode, CountryCodeList } from 'types/countries';

/**
 * Determines if schools should be shown for a given listing. This is a shared feature controller for all Canadian tenants.
 *
 * @param listingCountryCode The country code of the listing.
 * @param siteCountryCode The country code of the site.
 * @param userCountryCode The country code of the user.
 *
 * @returns `true` if the listing, site, and user are in Canada, `false` otherwise.
 */
export function canShowSchoolsCanadian(listingCountryCode: CountryCode, siteCountryCode: CountryCodeList, userCountryCode: CountryCode) {
  return listingCountryCode === CountryCodeList.CANADA && siteCountryCode === CountryCodeList.CANADA && userCountryCode === CountryCodeList.CANADA;
}